import { createFileRoute } from "@tanstack/react-router";

import { denyRouteAccess } from "@/core/lib/route-access";
import { canAccessTemplateEditorProjectType } from "@/routes/_protected/template-editor/index";

export const Route = createFileRoute(
  "/_protected/template-editor/statement-trees",
)({
  beforeLoad: ({ context, ...guard }) => {
    // the route fixes the project type, so org admins without audit
    // membership may open it, like the editor index with ?projectType=audit
    if (!canAccessTemplateEditorProjectType(context.user, "audit", true))
      denyRouteAccess(guard, "template_editor_access");
  },
});
